import { render, staticRenderFns } from "./buildsvg.vue?vue&type=template&id=093fde88&"
import script from "./buildsvg.vue?vue&type=script&lang=js&"
export * from "./buildsvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports